import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { AvatarVO } from "./AvatarVO";
import { VisualVO } from "./VisualVO";

export class BuddyVO extends VisualVO {
    public thumbUrl: string = "";
    public isSocialFriend: boolean = false;

    public pln: string;
    public playerId: number = 0;
    public playerName: string;
    public playerXp: number = NaN;
    public cashTotal: number = NaN;
    public currentTableId: number = 0;
    public isOnline: boolean = false;
    public avatarVO: AvatarVO;

    constructor() {
        super();
    }
}
classImplementsInterfaces(BuddyVO, "IInventoryVO");
